
































import { Component, Vue } from 'vue-property-decorator';
import Alert from '@/components/Alert.vue';
import { State, Action } from 'vuex-class';
import { RegionState, Region } from '@/store/region/types';
import Cards from '@/components/Cards.vue';
import Box from '@/components/Box.vue';
import { AbstractDataClass, column } from '../helpers/AbstractDataClass';

const namespace: string = 'region';

@Component({
  components: {
    Cards,
    Box,
    Alert,
  },
})
export default class Home extends Vue {
  @Action('get', { namespace: 'region' }) private get: () => void;
  @State('region') private regionState?: RegionState;

  private interval: number;

  private mounted() {
    this.get();

    // Auto refresh every 30s
    this.interval = setInterval(() => {
      this.get();
    }, 30000);
  }

  // Cancel auto refresh every 30s
  public beforeDestroy() {
    clearInterval(this.interval);
  }

  public orderSite(value: any) {
    return JSON.parse(JSON.stringify(value)).sort(function(a: any, b: any) {
      return a.name.localeCompare(b.name);
    });
  }

  public getBackgroundColorForSite(site: any) {
    if (
      site.devices == null ||
      site.devices == undefined ||
      site.devices.length == 0
    )
      return 'green';
    for (let i = 0; i < site.devices.length; i++) {
      if (site.devices[i].status == 'ERROR') return 'red';
    }
    for (let i = 0; i < site.devices.length; i++) {
      if (site.devices[i].status == 'WARNING') return 'yellow';
    }
    return 'green';
  }
  public getBackgroundColorForRegion(region: any) {
    if (
      region.adminsites == null ||
      region.adminsites == undefined ||
      region.adminsites.length == 0
    )
      return 'green';
    for (let i = 0; i < region.adminsites.length; i++) {
      if (this.getBackgroundColorForSite(region.adminsites[i]) == 'red')
        return 'red';
    }
    for (let i = 0; i < region.adminsites.length; i++) {
      if (this.getBackgroundColorForSite(region.adminsites[i]) == 'yellow')
        return 'yellow';
    }
    return 'green';
  }
  public getPictureForRegion(region: any) {
    if (
      region.adminsites == null ||
      region.adminsites == undefined ||
      region.adminsites.length == 0
    )
      return '';
    for (let i = 0; i < region.adminsites.length; i++) {
      if (this.getBackgroundColorForSite(region.adminsites[i]) == 'red')
        return 'noun_rain';
    }
    for (let i = 0; i < region.adminsites.length; i++) {
      if (this.getBackgroundColorForSite(region.adminsites[i]) == 'yellow')
        return 'noun_cloud';
    }
    return 'noun_sun';
  }
}
